import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder } from '@angular/forms'
import { LoadingController, ModalController } from '@ionic/angular'
import { first } from 'rxjs/operators'
import { AlertService } from '@services/utils/alerts/alert.service'
import { AuthService } from '@services/auth/auth.service'
import { ValidationService } from '@services/utils/validations/validation.service'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss']
})
export class ForgotPasswordPage implements OnInit {
  forgotPasswordForm: FormGroup
  userData: any

  typeInputRepeat: string = 'password'
  errorsMessages: string[] = []
  submitted: boolean = false

  constructor(
    private authService: AuthService,
    public formBuilder: FormBuilder,
    public loadingController: LoadingController,
    public modalController: ModalController,
    private alertService: AlertService,
    private validationService: ValidationService
  ) {}

  ngOnInit() {
    this.validateForm()
  }
  async resetPassword() {
    this.submitted = true
    let data = this.forgotPasswordForm.controls
    this.alertService.presentLoading()

    this.userData = {
      email: data.email.value
    }

    this.authService
      .resetPassword(this.userData)
      .pipe(first())
      .subscribe(
        (res) => {
          this.handleSuccess()
        },
        (err) => {
          this.handleError(err)
        }
      )
  }

  private handleSuccess() {
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert(
        'Correo enviado',
        'Se validará el correo electrónico digitado y se enviará una clave para restaurar la contraseña'
      )
      this.modalController.dismiss()
    })
  }

  private handleError(err: any) {
    const errorId = err?.payload?.data?.id
    const { title, message } = this.getErrorMessage(errorId)
    
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert(title, message)
      this.modalController.dismiss()
    })
  }

  private getErrorMessage(errorId: number) {
    const supportMessage = 'No fue posible restablecer la contraseña. Si el problema persiste, contacta a nuestro equipo de soporte. soporte@tbtbglobal.com'
    
    const errorMessages = {
      [-141]: { title: 'Error al restablecer la contraseña!', message: supportMessage },
      [-133]: { title: 'Error al restablecer la contraseña!', message: supportMessage }
    }
    
    return errorMessages[errorId] || {
      title: 'Error al restablecer la contraseña!',
      message: 'Ingrese un correo existente'
    }
  }

  validateForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [this.validationService.Validation(0, 50, 'onlyEmail')]]
    })
  }

  get errorControl() {
    return this.forgotPasswordForm.controls
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
